import React from 'react';

const Footer = props => {
    const { children } = props;
    return <>{children}</>;
};

export default Footer;
